/**
 * Expense calculation functions
 */

/**
 * Calculate VAT-exclusive amount from gross amount with VAT included
 * Formula: VAT-exclusive = Gross / (1 + VAT rate / 100)
 * 
 * @param grossAmount - Amount with VAT included
 * @param vatRate - VAT rate as percentage (e.g., 20 for 20%)
 * @returns VAT-exclusive amount
 */
export function calculateVATExclusive(grossAmount: number, vatRate: number): number {
  return grossAmount / (1 + vatRate / 100);
}

/**
 * Calculate tonnage expense with smart calculation
 * Given any two of three values (tonnage, unitPrice, totalAmount),
 * calculates the third value
 * 
 * @param tonnage - Tonnage amount
 * @param unitPrice - Price per unit
 * @param totalAmount - Total amount
 * @param field - Which field was last modified ('tonnage' | 'unitPrice' | 'totalAmount')
 * @returns Object with all three calculated values
 */
export function calculateTonnageExpense(
  tonnage: number,
  unitPrice: number,
  totalAmount: number,
  field: 'tonnage' | 'unitPrice' | 'totalAmount'
): { tonnage: number; unitPrice: number; totalAmount: number } {
  if (field === 'tonnage' || field === 'unitPrice') {
    // Calculate total from tonnage × unitPrice
    return {
      tonnage,
      unitPrice,
      totalAmount: tonnage * unitPrice,
    };
  } else {
    // field === 'totalAmount'
    // Calculate unitPrice from total / tonnage
    if (tonnage > 0) {
      return {
        tonnage,
        unitPrice: totalAmount / tonnage,
        totalAmount,
      };
    }
    return { tonnage, unitPrice, totalAmount };
  }
}
